import lottie from 'lottie-web'

let initLottieAnimations
let removeCanvas

if (!window.__lottieInitialized) {
  window.__lottieInitialized = true
  window.__lottieObserver = null

  removeCanvas = function (container) {
    container.querySelectorAll('canvas').forEach(canvas => canvas.remove())
  }

  initLottieAnimations = function () {
    const containers = document.querySelectorAll('.lottie:not([data-lottie-initialized])')
    if (containers.length === 0) return

    if (!window.__lottieObserver) {
      window.__lottieObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const animation = entry.target.lottieAnimation
          if (animation) {
            if (entry.isIntersecting) {
              animation.goToAndPlay(0)
            } else {
              animation.stop()
            }
          }
        })
      }, { threshold: 0.1 })
    }

    // Initialize each container
    containers.forEach((container) => {
      if (container.hasAttribute('data-lottie-initialized')) return

      // Clean up any existing animation
      if (container.lottieAnimation) {
        container.lottieAnimation.destroy()
      }

      container.innerHTML = ''
      const animationPath = container.getAttribute('data-animation-path')
      if (!animationPath) return

      // Load animation
      const anim = lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: animationPath
      })

      container.lottieAnimation = anim
      container.setAttribute('data-lottie-initialized', 'true')

      // Watch for and remove canvas elements
      const canvasWatcher = new MutationObserver(() => removeCanvas(container))
      canvasWatcher.observe(container, { childList: true, subtree: true })
      removeCanvas(container)

      window.__lottieObserver.observe(container)
    })
  }

  // Initialize on DOM ready
  const init = function () {
    requestAnimationFrame(initLottieAnimations)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  // Watch for dynamically added elements
  let mutationTimeout
  const domObserver = new MutationObserver(() => {
    clearTimeout(mutationTimeout)
    mutationTimeout = setTimeout(initLottieAnimations, 100)
  })

  const observeBody = function () {
    if (document.body) {
      domObserver.observe(document.body, { childList: true, subtree: true })
    }
  }

  if (document.body) {
    observeBody()
  } else {
    document.addEventListener('DOMContentLoaded', observeBody)
  }
}
